module.exports = __webpack_public_path__ + "assets/img/2020_1.e121aaa0.png";